import React from "react";
import { Box } from "@mui/system";
import { Tooltip } from "@mui/material";
import { TIER_CONFIG, LEVEL_CONFIG } from "network/apis/badges";
import { BadgeTier } from "network/apis/users";

interface BadgeAvatarProps {
  src?: string;
  alt?: string;
  size?: number;
  tier?: BadgeTier;
  level?: number | null;
  ringWidth?: number;
  className?: string;
}

const BadgeAvatar = ({
  src,
  alt = "",
  size = 45,
  tier,
  level,
  ringWidth = 3,
  className
}: BadgeAvatarProps) => {
  const ringColor =
    level && LEVEL_CONFIG[level] ? LEVEL_CONFIG[level].color : "transparent";

  const tierConfig = tier && TIER_CONFIG[tier] ? TIER_CONFIG[tier] : null;

  const ringOuterSize = size + (ringWidth + 2) * 2;

  const avatar = (
    <Box
      className={className}
      sx={{
        width: ringOuterSize,
        height: ringOuterSize,
        borderRadius: "50%",
        border: `${ringWidth}px solid ${ringColor}`,
        padding: "2px",
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        position: "relative",
        flexShrink: 0
      }}
    >
      <Box
        component="img"
        src={src}
        alt={alt}
        sx={{
          width: size,
          height: size,
          borderRadius: "50%",
          objectFit: "cover",
          display: "block"
        }}
      />
      {tierConfig && (
        <Box
          aria-label={`Tier: ${tierConfig.label}`}
          sx={{
            position: "absolute",
            bottom: 0,
            right: 0,
            width: 18,
            height: 18,
            borderRadius: "50%",
            background: "#FFFFFF",
            border: "1.5px solid #E5E7EB",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: "10px",
            lineHeight: 1,
            boxShadow: "0 1px 3px rgba(0,0,0,0.15)"
          }}
        >
          {tierConfig.icon}
        </Box>
      )}
    </Box>
  );

  if (tier || level) {
    const parts: string[] = [];
    if (tierConfig) {
      parts.push(`Quarter: ${tierConfig.label}`);
    }
    if (level && LEVEL_CONFIG[level]) {
      parts.push(`Lifetime: ${LEVEL_CONFIG[level].label}`);
    }
    return (
      <Tooltip title={parts.join(" | ")} arrow placement="bottom">
        {avatar}
      </Tooltip>
    );
  }

  return avatar;
};

export default BadgeAvatar;
